var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 74 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.737 25.057h-6.8804c-0.8179 0-1.4434-0.6252-1.4434-1.4427 0-0.7695 0.6736-1.4428 1.4434-1.4428h6.8804c0.8179 0 1.4434 0.6252 1.4434 1.4428 0 0.8175-0.6255 1.4427-1.4434 1.4427z",
    fill: "#9999E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.694 25.057h-6.8804c-0.8179 0-1.4434-0.6252-1.4434-1.4427 0-0.7695 0.6736-1.4428 1.4434-1.4428h6.8804c0.8179 0 1.4434 0.6252 1.4434 1.4428 0.0481 0.8175-0.6255 1.4427-1.4434 1.4427z",
    fill: "#9999E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.694 14.475h-6.8804c-0.8179 0-1.4434-0.6252-1.4434-1.4428 0-0.7695 0.6736-1.4428 1.4434-1.4428h6.8804c0.8179 0 1.4434 0.6253 1.4434 1.4428 0.0481 0.8176-0.6255 1.4428-1.4434 1.4428z",
    fill: "#9999E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.06 50.44c-0.8179 0-1.4434-0.6252-1.4434-1.4428v-26.98c0-0.7695 0.6736-1.4428 1.4434-1.4428 0.7699 0 1.4435 0.6252 1.4435 1.4428v26.98c0.0481 0.8176-0.6255 1.4428-1.4435 1.4428z",
    fill: "#9999E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.074 50.44c-0.818 0-1.4434-0.6252-1.4434-1.4428v-26.98c0-0.7695 0.6736-1.4428 1.4434-1.4428 0.8179 0 1.4434 0.6252 1.4434 1.4428v26.98c0 0.8176-0.6736 1.4428-1.4434 1.4428z",
    fill: "#9999E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m57.593 35.975h-6.8803c-0.818 0-1.4435-0.6252-1.4435-1.4428 0-0.7695 0.6736-1.4428 1.4435-1.4428h6.8803c0.818 0 1.4435 0.6253 1.4435 1.4428 0.0481 0.7695-0.6255 1.4428-1.4435 1.4428z",
    fill: "#9999E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m39.694 35.975h-6.8804c-0.8179 0-1.4434-0.6252-1.4434-1.4428 0-0.7695 0.6736-1.4428 1.4434-1.4428h6.8804c0.8179 0 1.4434 0.6253 1.4434 1.4428 0.0481 0.7695-0.6255 1.4428-1.4434 1.4428z",
    fill: "#9999E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m39.694 45.882h-6.8804c-0.8179 0-1.4434-0.6252-1.4434-1.4428 0-0.7695 0.6736-1.4428 1.4434-1.4428h6.8804c0.8179 0 1.4434 0.6252 1.4434 1.4428 0.0481 0.7695-0.6255 1.4428-1.4434 1.4428z",
    fill: "#9999E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m57.593 45.831h-6.8803c-0.818 0-1.4435-0.6252-1.4435-1.4428 0-0.7695 0.6736-1.4428 1.4435-1.4428h6.8803c0.818 0 1.4435 0.6252 1.4435 1.4428 0.0481 0.7695-0.6255 1.4428-1.4435 1.4428z",
    fill: "#9999E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.436 18.66-18.476-12.456v-4.7611c0-0.76948-0.6736-1.4428-1.4435-1.4428h-18.476c-0.818 0-1.4435 0.6252-1.4435 1.4428v11.109h-17.369c-0.81794 0-1.4434 0.6252-1.4434 1.4428v42.61c0 0.7694 0.6736 1.4427 1.4434 1.4427h56.342c0.818 0 1.4435-0.6252 1.4435-1.4427v-36.791c0.0962-0.4328-0.1444-0.9137-0.5774-1.1542zm-21.411-15.774v52.276h-15.541v-52.276h15.541zm-18.476 12.504v39.724h-15.878v-39.724h15.878zm37.626 39.724h-16.214v-45.399l16.214 10.917v34.482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.557 57.998h-71.113c-0.81794 0-1.4434-0.6252-1.4434-1.4428 0-0.7695 0.6736-1.4427 1.4434-1.4427h71.113c0.8179 0 1.4434 0.6252 1.4434 1.4427 0 0.8176-0.6255 1.4428-1.4434 1.4428z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 74,
    x2: -1.3943e-9,
    y1: 58,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14E6E6",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSite);
export default __webpack_public_path__ + "static/media/businessSite.794342de6cac1b08d88924c9ec4d9f3b.svg";
export { ForwardRef as ReactComponent };